module.exports = __webpack_public_path__ + "img/green-energy.8739984f.png";